module.exports = __webpack_public_path__ + "img/2-md.c2f249e3.jpg";